import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var RecipesFilled = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M13.3333 3.3335C11.9524 3.3335 10.8333 4.45266 10.8333 5.8335V14.1668V15.0002H9.16659V14.1668V5.8335C9.16659 4.45266 8.04742 3.3335 6.66659 3.3335H0.833252V15.0002C0.833252 15.921 1.57909 16.6668 2.49992 16.6668H4.16659V12.3668C3.18325 12.0335 2.49992 11.1252 2.49992 10.0002C2.49992 8.5835 3.58325 5.8335 4.99992 5.8335C6.41659 5.8335 7.49992 8.5835 7.49992 10.0002C7.49992 11.1252 6.81659 12.0335 5.83325 12.3668V16.6668H8.56409C8.85242 17.1627 9.38409 17.5002 9.99992 17.5002C10.6158 17.5002 11.1474 17.1627 11.4358 16.6668H17.4999C18.4208 16.6668 19.1666 15.921 19.1666 15.0002V3.3335H13.3333ZM17.4999 12.5002H16.6666H13.3333H12.4999V10.8335H13.3333H16.6666H17.4999V12.5002ZM17.4999 8.3335H16.6666H13.3333H12.4999V6.66683H13.3333H16.6666H17.4999V8.3335Z",
    fill: fill
  }));
};
export { RecipesFilled as default };
//# sourceMappingURL=RecipesFilled.js.map
